import { Drawer as BaseDrawer } from '@overdose/components'
import classNames from 'classnames'
import styles from './Drawer.module.css'
import { DrawerProps } from './Drawer.types'

const DEFAULT_DRAWER_WIDTH = 508
export const Drawer = ({
  title,
  children,
  isOpen,
  placement = 'right',
  onClose,
  wrapperClass,
  width = DEFAULT_DRAWER_WIDTH,
  theme,
  footer,
}: DrawerProps) => {
  return (
    <BaseDrawer
      width={width}
      theme={{
        wrapper: wrapperClass || '',
        root: styles[placement],
        mask: styles.mask,
        header: classNames('relative', { [theme?.header]: theme?.header }),
        close: classNames(styles.closeBtn, { [theme?.close]: theme?.close }),
        content: styles.content,
        title: classNames({ [theme?.title]: theme?.title }),
        inner: theme?.inner,
        footer: theme?.footer,
      }}
      title={title}
      visible={isOpen}
      placement={placement}
      onCancel={onClose}
      footer={footer}>
      {children}
    </BaseDrawer>
  )
}
